import { http } from '@/lib/public-http';
import * as Sentry from '@sentry/react';

export const axiosPublicBaseQuery =
  () =>
  async ({ url, method = 'get', params = null, data = null }) => {
    try {
      let config = {};
      if (method === 'get') {
        config.url = url;
        config.method = 'get';
        config.params = params;
      } else if (
        method === 'post' ||
        method === 'put' ||
        method === 'delete' ||
        method === 'patch'
      ) {
        config.url = url;
        config.method = method;
        config.params = params;
        config.data = data;
      }
      const result = await http(config);

      if (
        result?.errors?.length > 0 ||
        (result?.errors && Object.keys(result?.errors) > 0)
      ) {
        return {
          error: result?.errors,
        };
      }
      return {
        data: result?.data,
      };
    } catch (err) {
      Sentry.captureMessage('http-redux-query-error', (scope) => {
        scope.addBreadcrumb({
          data: {
            error: err,
          },
          level: 'info',
        });
      });
      return {
        error: err?.response?.data,
      };
    }
  };
